const words = [
  "网红翻车",
  "现场直击",
  "名场面",
  "视频回放",
  "关键截图",
  "直播事故",
  "带货失误",
  "连线失控",
  "人设崩塌",
];

export default function MarqueeBar() {
  const track = [...words, ...words];
  return (
    <section aria-hidden="true" className="w-full bg-accent-500 overflow-hidden border-y border-accent-600/40">
      <div className="flex items-center h-14 md:h-16">
        <div className="marquee-track flex w-max items-center">
          {track.map((word, index) => (
            <span
              key={`${word}-${index}`}
              className="flex items-center gap-6 px-6 font-heading font-bold text-lg md:text-2xl text-accent-950 whitespace-nowrap"
            >
              {word}
              <i className="ri-error-warning-line text-base opacity-70"></i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}